// src/pages/admin/editJobs/LiveSearchSelect.jsx — type-to-filter select (search box doubles
// as the trigger), used across EditJobsTab for customer/site pickers.
import { useMemo, useState } from "react";

export default function LiveSearchSelect({
  value,
  onChange,
  options = [],
  placeholder = "Search...",
  emptyText = "No results found.",
  className = "",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const selectedOption = useMemo(
    () => options.find((option) => option.value === value) || null,
    [options, value],
  );

  const filteredOptions = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;

    return options.filter((option) =>
      [option.label, option.searchText, option.description]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(q),
    );
  }, [options, query]);

  return (
    <div className={`relative ${className}`.trim()}>
      <input
        type="search"
        value={query}
        disabled={disabled}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
        onChange={(event) => {
          setQuery(event.target.value);
          setOpen(true);
        }}
        placeholder={selectedOption?.label || placeholder}
        className={`w-full rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-500 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 ${
          disabled ? "cursor-not-allowed bg-gray-100 text-gray-400" : ""
        }`}
      />

      {open && !disabled && (
        <div className="absolute left-0 right-0 top-[46px] z-50 mt-2 max-h-64 overflow-auto rounded-xl border border-gray-200 bg-white p-1.5 shadow-lg">
          {filteredOptions.length ? (
            filteredOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => {
                  onChange(option.value);
                  setQuery(option.label);
                  setOpen(false);
                }}
                className={`mb-1 flex w-full flex-col items-start rounded-lg px-3 py-2 text-left text-sm transition ${
                  option.value === value
                    ? "bg-emerald-50 text-emerald-700"
                    : "text-gray-800 hover:bg-gray-50"
                }`}
              >
                <span className="font-medium">{option.label}</span>
                {option.description ? (
                  <span className="mt-0.5 text-xs text-gray-500">
                    {option.description}
                  </span>
                ) : null}
              </button>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">{emptyText}</div>
          )}
        </div>
      )}

    </div>
  );
}
